export default __webpack_public_path__ + "static/lb-09-f22f8afee5af3ce82491b484f0f1ef38.webp";